import watermarkGenerator from 'pages/Batch/utils/watermark/watermarkGenerator';
import loadingImage from 'utils/images/loadingImage';

const watermarkGeneratorInit = async (url: string) => {
  const logo = await loadingImage(url);
  watermarkGenerator.init(logo);
};

export default watermarkGeneratorInit;
